import type { CSSProperties } from "react";

export interface HairlineProps {
  color?: string;
  style?: CSSProperties;
}

export function Hairline({
  color = "var(--ink-100)",
  style,
}: HairlineProps) {
  return <div style={{ height: 1, background: color, ...style }} />;
}
